import actionTypes from './actionTypes';

const INITIAL_STATE = {
  loginOrRegisterLoading: false,
  loginOrRegisterFailed: false,
  loginOrRegisterReject: false,
  loginOrRegisterMessage: [],
  loginType: [],

  registerNewUserLoading: false,
  registerNewUserFailed: false,
  registerNewUserReject: false,
  registerNewUserMessage: [],

  sendVerificationCodeLoading: false,
  sendVerificationCodeFailed: false,
  sendVerificationCodeReject: false,
  sendVerificationCodeMessage: [],
  sendVerificationCode: [],

  loginByVerifyPhoneNumberLoading: false,
  loginByVerifyPhoneNumberFailed: false,
  loginByVerifyPhoneNumberReject: false,
  loginByVerifyPhoneNumberMessage: [],
  loginByVerifyPhoneNumber: [],

  loginByPasswordLoading: false,
  loginByPasswordFailed: false,
  loginByPasswordReject: false,
  loginByPasswordMessage: [],
  loginByPassword: [],

  setPasswordLoading: false,
  setPasswordFailed: false,
  setPasswordReject: false,
  setPasswordMessage: [],

  changePasswordLoading: false,
  changePasswordFailed: false,
  changePasswordReject: false,
  changePasswordMessage: [],

  forgetPasswordLoading: false,
  forgetPasswordFailed: false,
  forgetPasswordReject: false,
  forgetPasswordMessage: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_OR_REGISTER_LOADING: {
      return {
        ...state,
        loginOrRegisterLoading: true,
        loginOrRegisterFailed: false,
        loginOrRegisterReject: false,
        loginOrRegisterMessage: [],
        loginType: [],
      };
    }
    case actionTypes.LOGIN_OR_REGISTER_SUCCESS: {
      return {
        ...state,
        loginOrRegisterLoading: false,
        loginOrRegisterFailed: false,
        loginOrRegisterReject: false,
        loginOrRegisterMessage: [],
        loginType: action.payload,
      };
    }
    case actionTypes.LOGIN_OR_REGISTER_FAILED: {
      return {
        ...state,
        loginOrRegisterLoading: false,
        loginOrRegisterFailed: true,
        loginOrRegisterReject: false,
        loginOrRegisterMessage: [],
        loginType: [],
      };
    }
    case actionTypes.LOGIN_OR_REGISTER_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        loginOrRegisterLoading: false,
        loginOrRegisterFailed: false,
        loginOrRegisterReject: true,
        loginOrRegisterMessage: message,
        loginType: [],
      };
    }

    case actionTypes.REGISTER_NEW_USER_LOADING: {
      return {
        ...state,
        registerNewUserLoading: true,
        registerNewUserFailed: false,
        registerNewUserReject: false,
        registerNewUserMessage: [],
      };
    }
    case actionTypes.REGISTER_NEW_USER_SUCCESS: {
      return {
        ...state,
        registerNewUserLoading: false,
        registerNewUserFailed: false,
        registerNewUserReject: false,
        registerNewUserMessage: action.payload,
      };
    }
    case actionTypes.REGISTER_NEW_USER_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        registerNewUserLoading: false,
        registerNewUserFailed: true,
        registerNewUserReject: false,
        registerNewUserMessage: message,
      };
    }
    case actionTypes.REGISTER_NEW_USER_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        registerNewUserLoading: false,
        registerNewUserFailed: false,
        registerNewUserReject: true,
        registerNewUserMessage: message,
      };
    }

    case actionTypes.SEND_VERIFICATION_CODE_LOADING: {
      return {
        ...state,
        sendVerificationCodeLoading: true,
        sendVerificationCodeFailed: false,
        sendVerificationCodeReject: false,
        sendVerificationCodeMessage: [],
        sendVerificationCode: [],
      };
    }
    case actionTypes.SEND_VERIFICATION_CODE_SUCCESS: {
      return {
        ...state,
        sendVerificationCodeLoading: false,
        sendVerificationCodeFailed: false,
        sendVerificationCodeReject: false,
        sendVerificationCodeMessage: [],
        sendVerificationCode: action.payload,
      };
    }
    case actionTypes.SEND_VERIFICATION_CODE_FAILED: {
      return {
        ...state,
        sendVerificationCodeLoading: false,
        sendVerificationCodeFailed: true,
        sendVerificationCodeReject: false,
        sendVerificationCodeMessage: [],
        sendVerificationCode: [],
      };
    }
    case actionTypes.SEND_VERIFICATION_CODE_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        sendVerificationCodeLoading: false,
        sendVerificationCodeFailed: false,
        sendVerificationCodeReject: false,
        sendVerificationCodeMessage: message,
        sendVerificationCode: [],
      };
    }

    case actionTypes.LOGIN_BY_VERIFICATION_CODE_LOADING: {
      return {
        ...state,
        loginByVerifyPhoneNumberLoading: true,
        loginByVerifyPhoneNumberFailed: false,
        loginByVerifyPhoneNumberReject: false,
        loginByVerifyPhoneNumberMessage: [],
        loginByVerifyPhoneNumber: [],
      };
    }
    case actionTypes.LOGIN_BY_VERIFICATION_CODE_SUCCESS: {
      return {
        ...state,
        loginByVerifyPhoneNumberLoading: false,
        loginByVerifyPhoneNumberFailed: false,
        loginByVerifyPhoneNumberReject: false,
        loginByVerifyPhoneNumberMessage: [],
        loginByVerifyPhoneNumber: action.payload,
      };
    }
    case actionTypes.LOGIN_BY_VERIFICATION_CODE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        loginByVerifyPhoneNumberLoading: false,
        loginByVerifyPhoneNumberFailed: true,
        loginByVerifyPhoneNumberReject: false,
        loginByVerifyPhoneNumberMessage: message,
        loginByVerifyPhoneNumber: [],
      };
    }
    case actionTypes.LOGIN_BY_VERIFICATION_CODE_REJECT: {
      return {
        ...state,
        loginByVerifyPhoneNumberLoading: false,
        loginByVerifyPhoneNumberFailed: false,
        loginByVerifyPhoneNumberReject: true,
        loginByVerifyPhoneNumberMessage: [],
        loginByVerifyPhoneNumber: [],
      };
    }

    case actionTypes.LOGIN_BY_PASSWORD_LOADING: {
      return {
        ...state,
        loginByPasswordLoading: true,
        loginByPasswordFailed: false,
        loginByPasswordReject: false,
        loginByPasswordMessage: [],
        loginByPassword: [],
      };
    }
    case actionTypes.LOGIN_BY_PASSWORD_SUCCESS: {
      return {
        ...state,
        loginByPasswordLoading: false,
        loginByPasswordFailed: false,
        loginByPasswordReject: false,
        loginByPasswordMessage: [],
        loginByPassword: action.payload,
      };
    }
    case actionTypes.LOGIN_BY_PASSWORD_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        loginByPasswordLoading: false,
        loginByPasswordFailed: true,
        loginByPasswordReject: false,
        loginByPasswordMessage: message,
        loginByPassword: [],
      };
    }
    case actionTypes.LOGIN_BY_PASSWORD_REJECT: {
      // const { message } = action.payload;
      return {
        ...state,
        loginByPasswordLoading: false,
        loginByPasswordFailed: false,
        loginByPasswordReject: false,
        loginByPasswordMessage: [],
        loginByPassword: [],
      };
    }

    case actionTypes.SET_PASSWORD_LOADING: {
      return {
        ...state,
        setPasswordLoading: true,
        setPasswordFailed: false,
        setPasswordReject: false,
        setPasswordMessage: [],
      };
    }
    case actionTypes.SET_PASSWORD_SUCCESS: {
      return {
        ...state,
        setPasswordLoading: false,
        setPasswordFailed: false,
        setPasswordReject: false,
        setPasswordMessage: action.payload,
      };
    }
    case actionTypes.SET_PASSWORD_FAILED: {
      return {
        ...state,
        setPasswordLoading: false,
        setPasswordFailed: true,
        setPasswordReject: false,
        setPasswordMessage: [],
      };
    }
    case actionTypes.SET_PASSWORD_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        setPasswordLoading: false,
        setPasswordFailed: false,
        setPasswordReject: true,
        setPasswordMessage: message,
      };
    }

    case actionTypes.CHANGE_PASSWORD_LOADING: {
      return {
        ...state,
        changePasswordLoading: true,
        changePasswordFailed: false,
        changePasswordReject: false,
        changePasswordMessage: [],
      };
    }
    case actionTypes.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        changePasswordLoading: false,
        changePasswordFailed: false,
        changePasswordReject: false,
        changePasswordMessage: [],
      };
    }
    case actionTypes.CHANGE_PASSWORD_FAILED: {
      return {
        ...state,
        changePasswordLoading: false,
        changePasswordFailed: true,
        changePasswordReject: false,
        changePasswordMessage: [],
      };
    }
    case actionTypes.CHANGE_PASSWORD_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        changePasswordLoading: false,
        changePasswordFailed: false,
        changePasswordReject: true,
        changePasswordMessage: message,
      };
    }

    case actionTypes.FORGET_PASSWORD_LOADING: {
      return {
        ...state,
        forgetPasswordLoading: true,
        forgetPasswordFailed: false,
        forgetPasswordReject: false,
        forgetPasswordMessage: [],
      };
    }
    case actionTypes.FORGET_PASSWORD_SUCCESS: {
      return {
        ...state,
        forgetPasswordLoading: false,
        forgetPasswordFailed: false,
        forgetPasswordReject: false,
        forgetPasswordMessage: [],
      };
    }
    case actionTypes.FORGET_PASSWORD_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        forgetPasswordLoading: false,
        forgetPasswordFailed: true,
        forgetPasswordReject: false,
        forgetPasswordMessage: message,
      };
    }
    case actionTypes.FORGET_PASSWORD_REJECT: {
      return {
        ...state,
        forgetPasswordLoading: false,
        forgetPasswordFailed: false,
        forgetPasswordReject: true,
        forgetPasswordMessage: [],
      };
    }

    default:
      return state;
  }
};
